/**
 * 学习乐园 · 排排序题材包：元素周期前 20（paixu/pack-yuansu.js）
 * ---------------------------------------------------------------------------
 * 每局从前 20 号元素里随机抽 8 个按原子序排回（m 选 n）。口径如实：
 * 只收 1~20 号（氢到钙）——这是中学要求熟背的段，21 号起进入过渡金属，
 * 不在本包的考点里。face 只写元素名（考「背原子序」本身），note 带
 * 序号与一句特征——查一查讲错位时，序号就顺带读出来了。
 * items 顺序即正确答案；同包 face 不得重复（排序题天然满足）。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  PACKS.yuansu = {
    id: 'yuansu',
    name: '元素周期（前 20）',
    hint: '每局抽 8 个元素按原子序排',
    cols: 4,
    draw: 8,
    winText: '氢氦锂铍硼，碳氮氧氟氖，钠镁铝硅磷，硫氯氩钾钙——前 20 号元素一句口诀背完。',
    items: [
      { face: '氢', note: '1 号，宇宙里最多的元素' },
      { face: '氦', note: '2 号，最轻的稀有气体' },
      { face: '锂', note: '3 号，最轻的金属，电池常用' },
      { face: '铍', note: '4 号，轻而硬的金属' },
      { face: '硼', note: '5 号，非金属，玻璃与洗涤剂里有它' },
      { face: '碳', note: '6 号，生命的骨架，钻石和石墨都是它' },
      { face: '氮', note: '7 号，空气里近八成是它' },
      { face: '氧', note: '8 号，呼吸与燃烧都靠它' },
      { face: '氟', note: '9 号，最活泼的非金属，牙膏里有氟化物' },
      { face: '氖', note: '10 号，霓虹灯的红光来自它' },
      { face: '钠', note: '11 号，食盐（氯化钠）的一半' },
      { face: '镁', note: '12 号，燃烧发白光，叶绿素的中心' },
      { face: '铝', note: '13 号，地壳里最多的金属' },
      { face: '硅', note: '14 号，沙子与芯片的主角' },
      { face: '磷', note: '15 号，火柴与骨骼里都有它' },
      { face: '硫', note: '16 号，火山口的黄色固体' },
      { face: '氯', note: '17 号，自来水的消毒气味来自它' },
      { face: '氩', note: '18 号，空气里最多的稀有气体' },
      { face: '钾', note: '19 号，香蕉里的矿物质，神经传导要靠它' },
      { face: '钙', note: '20 号，骨骼与牙齿的主要成分，前 20 号收尾' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
